import React from 'react';
import { Helmet } from '@okapi/helmet-react';
import { useSelector } from 'react-redux';
import { selectPageModelSE0 } from 'store/pageModel';

export const MetaOpenGraphProduct = () => {
	const pageModelSEO = useSelector(selectPageModelSE0);

	const title = pageModelSEO?.pageTitle || '';
	const description = pageModelSEO?.metadescription || '';
	const canonical = pageModelSEO?.canonicalURL || '';

	return (
		<Helmet>
			<meta property="og:title" content={title} />
			<meta property="og:description" content={description} />
			<meta property="og:type" content="website" />
			<meta
				property="og:image"
				content="https://cdn.lemanapro.ru/lmru/image/upload/other/logo/logo.svg?r=2162094"
			/>
			<meta property="og:url" content={canonical} />
		</Helmet>
	);
};
